module.exports = {
      id: "home-usage",
      viewBox: "0 0 15.417 13.987",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#home",
      toString: function () {
        return this.url;
      }
    }